<template>
  <section
    class="bg-gradient-to-r from-gray-100/70 to-gray-100 relative py-16 sm:py-24"
  >
    <div class="container relative">
      <h1 class="text-3xl/tight font-medium mb-4">Faturalarım</h1>
    </div>
    <div v-if="isLoading" class="flex justify-center items-center h-screen">
      <i class="fas fa-spinner fa-spin text-5xl"></i>
    </div>
    <div v-else>
      <div v-if="invoices.length === 0">
        <img
          :src="require('@/assets/receipt.png')"
          alt="No Invoices"
          class="h-48 w-48 mx-auto mb-4"
        />
        <p class="text-center text-gray-500">Henüz faturanız yok.</p>
      </div>
      <InvoiceListView :invoices="invoices" />
    </div>

    <div class="mt-8 mb-8"></div>

    <div class="container relative">
      <h1 class="text-3xl/tight font-medium mb-4">Fatura Bilgilerim</h1>
    </div>
    <div
      v-if="isInvoiceInfoLoading"
      class="flex justify-center items-center h-screen"
    >
      <i class="fas fa-spinner fa-spin text-5xl"></i>
    </div>
    <div v-else>
      <InvoiceInformationListView :invoiceInformation="invoiceInformation" />
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  getUserInvoices,
  fetchAllUserInvoiceInformations,
} from "@/services/userServices";
import InvoiceListView from "@/views/InvoicesListView.vue";
import InvoiceInformationListView from "@/views/InvoiceInformationListView.vue";

const invoices = ref([]);
const invoiceInformation = ref([]);
const isLoading = ref(true);
const isInvoiceInfoLoading = ref(true);

onMounted(async () => {
  invoices.value = await getUserInvoices();
  invoiceInformation.value = await fetchAllUserInvoiceInformations();
  isLoading.value = false;
  isInvoiceInfoLoading.value = false;
});
</script>
